import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import ProposalSendForm from './ProposalSendForm';

function formatContactData(jsonObject) {
  return jsonObject.map(item => ({
    label: `${item.first_name} ${item.last_name} (${item.email})`,
    value: item.id,
  }));
}
function getInitialValues(jsonObject) {
  return jsonObject.map(item => (item.id));
}


class ProposalSendMenu extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(values) {
    this.props.sendProposal(
      this.props.proposal.id,
      values,
    );
    this.props.close();
  }
  render() {
    const initialValues = { contacts: getInitialValues(this.props.proposal.contacts) };
    const mergedContacts = Array.from(
        new Set(
          this.props.proposal.saved_contacts.concat(
            this.props.proposal.contacts,
          ),
        ),
      );
    const contactOptions = formatContactData(mergedContacts);
    return (
      <Modal show={this.props.show} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title>Request Bids</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Send the bid request to your {this.props.proposal.brand.name} sales rep.</p>
          <ProposalSendForm
            onSubmit={this.handleSubmit}
            initialValues={initialValues}
            options={contactOptions}
          />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
}

ProposalSendMenu.propTypes = {
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  proposal: PropTypes.object.isRequired,
  sendProposal: PropTypes.func.isRequired,
};

ProposalSendMenu.defaultProps = {
  proposal: {
    contacts: [],
    bids: [],
  },
};
export default ProposalSendMenu;



// WEBPACK FOOTER //
// src/routes/tours/components/ProposalSendModal.js